import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../configHelper';
import { ClaimSubmissionDto } from '../models/prepay-dto';

@Injectable({
   providedIn: 'root'
})
export class BillingDataService {

   constructor(private httpClient: HttpClient, private configService: ConfigService) {
  }
  public getDetail(id) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Billing?id=${id}`;
    return this.httpClient.get(url);
  }

   public sendToAdvancedMD(accession) {
     let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Billing/SendToAdvancedMD?accession=${accession}`;
     return this.httpClient.get(url);
   }

   public getList(dto) {
     let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Billing/GetList`;
     return this.httpClient.post(url, dto);
   }

   public getCarriers(search) {
     let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Billing/LookupADMCarriers?search=${search}`;
      return this.httpClient.get(url);
   }

   public updateRequisition(req) {
      if (req.Id === 0) return;
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Requisition/?id=${req.Id}`;
      return this.httpClient.put(url, req);
   }

  public updateRequisitionPay(dto) {
    if (dto.Id === 0) return;
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Billing/UpdateRequisitionPay`;
    return this.httpClient.put(url, dto);
  }

  public getPrepayAmount(id) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Billing/GetPrepayAmount?id=${id}`;
    return this.httpClient.get(url);
  }

  public savePrepay(dto) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Billing/SavePrepay`;
    return this.httpClient.post(url, dto);
  }

  public getFilters() {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Billing/GetFilters`;
    return this.httpClient.get(url);
  }

  public saveEmail(dto) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Billing/SaveEmail`;
    return this.httpClient.post(url, dto);
  }

  public savePhone(dto) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Billing/SavePhone`;
    return this.httpClient.post(url, dto);
  }

  public savePreAuthCode(dto) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Billing/SavePreAuthCode`;
    return this.httpClient.post(url, dto);
  }

  public saveBillingOptions(dto) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Billing/SaveBillingOptions`;
    return this.httpClient.post(url, dto);
  }

  public getClientInstBillingSettings(id) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Billing/ClientInstBill?id=${id}`;
    return this.httpClient.get(url);
  }

  public saveClientInstBillingSettings(dto) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Billing/ClientInstBill`;
    return this.httpClient.post(url, dto);
  }

  public getResultReportByAccession(accession: any) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Billing/GetResultReportByAccession?sid=${accession}`;
    return this.httpClient.get(url, { responseType: 'blob' as 'json' });
  }

  public saveClaimSubmission(dto: ClaimSubmissionDto) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Billing/SaveClaimSubmission`;
    return this.httpClient.post(url, dto);
  }

  public getSubstatuses() {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Billing/BillingSubstatuses`;
    return this.httpClient.get(url);
  }

  public getReportXLSX(dto) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Billing/GetReportXLSX`;
    return this.httpClient.post(url,dto, { responseType: 'blob' as 'json' });
  }

  public getReport(dto) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Billing/GetReport`;
    return this.httpClient.post(url, dto);
  }

}
